"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
require("core-js/modules/es6.regexp.split.js");
require("core-js/modules/es6.array.map.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactIntl = require("react-intl");
var _get = _interopRequireDefault(require("lodash/get"));
var _cartIndicator = _interopRequireDefault(require("@gravity/cart-indicator"));
var _languageSelector = _interopRequireDefault(require("@gravity/language-selector"));
var _config = require("@nucleo/config");
var _logo = _interopRequireDefault(require("@gravity/logo"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _utils = require("@gravity/utils");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _tsMobileMenu = require("@gravity/ts-mobile-menu");
var _UserInfo = _interopRequireDefault(require("./UserInfo"));
var _CustomLinks = _interopRequireDefault(require("./CustomLinks"));
var _TsHeaderHelper = require("./TsHeaderHelper");
var _HeaderStyles = require("./HeaderStyles");
var _jsxFileName = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/TsHeader.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_b4bbjxzqs() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/TsHeader.js";
  var hash = "48be6fd071d433532e30abe5774e285cea8382a0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/TsHeader.js",
    statementMap: {
      "0": {
        start: {
          line: 32,
          column: 25
        },
        end: {
          line: 32,
          column: 40
        }
      },
      "1": {
        start: {
          line: 34,
          column: 33
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "2": {
        start: {
          line: 35,
          column: 17
        },
        end: {
          line: 35,
          column: 27
        }
      },
      "3": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 24
        }
      },
      "4": {
        start: {
          line: 39,
          column: 23
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "5": {
        start: {
          line: 44,
          column: 20
        },
        end: {
          line: 49,
          column: 1
        }
      },
      "6": {
        start: {
          line: 51,
          column: 19
        },
        end: {
          line: 58,
          column: 1
        }
      },
      "7": {
        start: {
          line: 60,
          column: 17
        },
        end: {
          line: 75,
          column: 1
        }
      },
      "8": {
        start: {
          line: 77,
          column: 28
        },
        end: {
          line: 79,
          column: 4
        }
      },
      "9": {
        start: {
          line: 81,
          column: 21
        },
        end: {
          line: 81,
          column: 35
        }
      },
      "10": {
        start: {
          line: 82,
          column: 17
        },
        end: {
          line: 84,
          column: 1
        }
      },
      "11": {
        start: {
          line: 85,
          column: 26
        },
        end: {
          line: 85,
          column: 43
        }
      },
      "12": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 17
        }
      },
      "13": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 43
        }
      },
      "14": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 94,
          column: 5
        }
      },
      "15": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 61
        }
      },
      "16": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 101,
          column: 5
        }
      },
      "17": {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 100,
          column: 41
        }
      },
      "18": {
        start: {
          line: 104,
          column: 26
        },
        end: {
          line: 109,
          column: 3
        }
      },
      "19": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 108,
          column: 5
        }
      },
      "20": {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 107,
          column: 30
        }
      },
      "21": {
        start: {
          line: 111,
          column: 19
        },
        end: {
          line: 122,
          column: 3
        }
      },
      "22": {
        start: {
          line: 112,
          column: 22
        },
        end: {
          line: 112,
          column: 56
        }
      },
      "23": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "24": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 60
        }
      },
      "25": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 56
        }
      },
      "26": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 34
        }
      },
      "27": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 25
        }
      },
      "28": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 23
        }
      },
      "29": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 127,
          column: 8
        }
      },
      "30": {
        start: {
          line: 125,
          column: 25
        },
        end: {
          line: 127,
          column: 5
        }
      },
      "31": {
        start: {
          line: 130,
          column: 20
        },
        end: {
          line: 150,
          column: 3
        }
      },
      "32": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 133,
          column: 5
        }
      },
      "33": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 132,
          column: 18
        }
      },
      "34": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 149,
          column: 6
        }
      },
      "35": {
        start: {
          line: 135,
          column: 32
        },
        end: {
          line: 135,
          column: 40
        }
      },
      "36": {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 143,
          column: 7
        }
      },
      "37": {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 142,
          column: 9
        }
      },
      "38": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 148,
          column: 7
        }
      },
      "39": {
        start: {
          line: 151,
          column: 21
        },
        end: {
          line: 174,
          column: 3
        }
      },
      "40": {
        start: {
          line: 159,
          column: 8
        },
        end: {
          line: 159,
          column: 13
        }
      },
      "41": {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 173,
          column: 5
        }
      },
      "42": {
        start: {
          line: 177,
          column: 40
        },
        end: {
          line: 177,
          column: 50
        }
      },
      "43": {
        start: {
          line: 178,
          column: 23
        },
        end: {
          line: 178,
          column: 62
        }
      },
      "44": {
        start: {
          line: 179,
          column: 28
        },
        end: {
          line: 179,
          column: 80
        }
      },
      "45": {
        start: {
          line: 180,
          column: 26
        },
        end: {
          line: 180,
          column: 76
        }
      },
      "46": {
        start: {
          line: 181,
          column: 30
        },
        end: {
          line: 181,
          column: 60
        }
      },
      "47": {
        start: {
          line: 182,
          column: 24
        },
        end: {
          line: 182,
          column: 55
        }
      },
      "48": {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 187,
          column: 13
        }
      },
      "49": {
        start: {
          line: 189,
          column: 19
        },
        end: {
          line: 189,
          column: 67
        }
      },
      "50": {
        start: {
          line: 190,
          column: 31
        },
        end: {
          line: 190,
          column: 62
        }
      },
      "51": {
        start: {
          line: 191,
          column: 32
        },
        end: {
          line: 191,
          column: 102
        }
      },
      "52": {
        start: {
          line: 192,
          column: 26
        },
        end: {
          line: 192,
          column: 82
        }
      },
      "53": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 324,
          column: 6
        }
      },
      "54": {
        start: {
          line: 234,
          column: 20
        },
        end: {
          line: 238,
          column: 34
        }
      },
      "55": {
        start: {
          line: 328,
          column: 0
        },
        end: {
          line: 342,
          column: 2
        }
      },
      "56": {
        start: {
          line: 344,
          column: 0
        },
        end: {
          line: 369,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 34,
            column: 33
          },
          end: {
            line: 34,
            column: 34
          }
        },
        loc: {
          start: {
            line: 34,
            column: 40
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 34
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 89,
            column: 21
          },
          end: {
            line: 96,
            column: 3
          }
        },
        line: 89
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 98,
            column: 3
          }
        },
        loc: {
          start: {
            line: 98,
            column: 23
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 98
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 104,
            column: 26
          },
          end: {
            line: 104,
            column: 27
          }
        },
        loc: {
          start: {
            line: 104,
            column: 31
          },
          end: {
            line: 109,
            column: 3
          }
        },
        line: 104
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 111,
            column: 19
          },
          end: {
            line: 111,
            column: 20
          }
        },
        loc: {
          start: {
            line: 111,
            column: 26
          },
          end: {
            line: 122,
            column: 3
          }
        },
        line: 111
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 3
          }
        },
        loc: {
          start: {
            line: 124,
            column: 21
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 124
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 125,
            column: 18
          },
          end: {
            line: 125,
            column: 19
          }
        },
        loc: {
          start: {
            line: 125,
            column: 25
          },
          end: {
            line: 127,
            column: 5
          }
        },
        line: 125
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 130,
            column: 20
          },
          end: {
            line: 130,
            column: 21
          }
        },
        loc: {
          start: {
            line: 130,
            column: 33
          },
          end: {
            line: 150,
            column: 3
          }
        },
        line: 130
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 134,
            column: 25
          },
          end: {
            line: 134,
            column: 26
          }
        },
        loc: {
          start: {
            line: 134,
            column: 37
          },
          end: {
            line: 149,
            column: 5
          }
        },
        line: 134
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 151,
            column: 21
          },
          end: {
            line: 151,
            column: 22
          }
        },
        loc: {
          start: {
            line: 151,
            column: 30
          },
          end: {
            line: 174,
            column: 3
          }
        },
        line: 151
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 176,
            column: 2
          },
          end: {
            line: 176,
            column: 3
          }
        },
        loc: {
          start: {
            line: 176,
            column: 11
          },
          end: {
            line: 325,
            column: 3
          }
        },
        line: 176
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 233,
            column: 19
          },
          end: {
            line: 233,
            column: 20
          }
        },
        loc: {
          start: {
            line: 234,
            column: 20
          },
          end: {
            line: 238,
            column: 34
          }
        },
        line: 234
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 334,
            column: 18
          },
          end: {
            line: 334,
            column: 19
          }
        },
        loc: {
          start: {
            line: 334,
            column: 24
          },
          end: {
            line: 334,
            column: 26
          }
        },
        line: 334
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 341,
            column: 28
          },
          end: {
            line: 341,
            column: 29
          }
        },
        loc: {
          start: {
            line: 341,
            column: 34
          },
          end: {
            line: 341,
            column: 36
          }
        },
        line: 341
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 101,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 101,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 99
      },
      "1": {
        loc: {
          start: {
            line: 99,
            column: 7
          },
          end: {
            line: 99,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 7
          },
          end: {
            line: 99,
            column: 34
          }
        }, {
          start: {
            line: 99,
            column: 38
          },
          end: {
            line: 99,
            column: 56
          }
        }, {
          start: {
            line: 99,
            column: 60
          },
          end: {
            line: 99,
            column: 86
          }
        }],
        line: 99
      },
      "2": {
        loc: {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 108,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 105
      },
      "3": {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }, {
          start: {
            line: 116,
            column: 11
          },
          end: {
            line: 118,
            column: 5
          }
        }],
        line: 114
      },
      "4": {
        loc: {
          start: {
            line: 114,
            column: 8
          },
          end: {
            line: 114,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 114,
            column: 8
          },
          end: {
            line: 114,
            column: 17
          }
        }, {
          start: {
            line: 114,
            column: 22
          },
          end: {
            line: 114,
            column: 42
          }
        }, {
          start: {
            line: 114,
            column: 46
          },
          end: {
            line: 114,
            column: 70
          }
        }],
        line: 114
      },
      "5": {
        loc: {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 133,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 133,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 131
      },
      "6": {
        loc: {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 143,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 143,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 137
      },
      "7": {
        loc: {
          start: {
            line: 137,
            column: 9
          },
          end: {
            line: 137,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 9
          },
          end: {
            line: 137,
            column: 17
          }
        }, {
          start: {
            line: 137,
            column: 21
          },
          end: {
            line: 137,
            column: 26
          }
        }],
        line: 137
      },
      "8": {
        loc: {
          start: {
            line: 179,
            column: 28
          },
          end: {
            line: 179,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 179,
            column: 28
          },
          end: {
            line: 179,
            column: 44
          }
        }, {
          start: {
            line: 179,
            column: 48
          },
          end: {
            line: 179,
            column: 80
          }
        }],
        line: 179
      },
      "9": {
        loc: {
          start: {
            line: 180,
            column: 26
          },
          end: {
            line: 180,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 180,
            column: 26
          },
          end: {
            line: 180,
            column: 42
          }
        }, {
          start: {
            line: 180,
            column: 46
          },
          end: {
            line: 180,
            column: 76
          }
        }],
        line: 180
      },
      "10": {
        loc: {
          start: {
            line: 181,
            column: 30
          },
          end: {
            line: 181,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 181,
            column: 30
          },
          end: {
            line: 181,
            column: 55
          }
        }, {
          start: {
            line: 181,
            column: 59
          },
          end: {
            line: 181,
            column: 60
          }
        }],
        line: 181
      },
      "11": {
        loc: {
          start: {
            line: 184,
            column: 6
          },
          end: {
            line: 187,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 184,
            column: 7
          },
          end: {
            line: 184,
            column: 24
          }
        }, {
          start: {
            line: 185,
            column: 8
          },
          end: {
            line: 185,
            column: 39
          }
        }, {
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 186,
            column: 59
          }
        }, {
          start: {
            line: 187,
            column: 6
          },
          end: {
            line: 187,
            column: 13
          }
        }],
        line: 184
      },
      "12": {
        loc: {
          start: {
            line: 191,
            column: 32
          },
          end: {
            line: 191,
            column: 102
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 191,
            column: 62
          },
          end: {
            line: 191,
            column: 95
          }
        }, {
          start: {
            line: 191,
            column: 98
          },
          end: {
            line: 191,
            column: 102
          }
        }],
        line: 191
      },
      "13": {
        loc: {
          start: {
            line: 195,
            column: 37
          },
          end: {
            line: 195,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 195,
            column: 37
          },
          end: {
            line: 195,
            column: 43
          }
        }, {
          start: {
            line: 195,
            column: 47
          },
          end: {
            line: 195,
            column: 74
          }
        }],
        line: 195
      },
      "14": {
        loc: {
          start: {
            line: 201,
            column: 9
          },
          end: {
            line: 215,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 201,
            column: 9
          },
          end: {
            line: 201,
            column: 24
          }
        }, {
          start: {
            line: 202,
            column: 10
          },
          end: {
            line: 214,
            column: 32
          }
        }],
        line: 201
      },
      "15": {
        loc: {
          start: {
            line: 216,
            column: 9
          },
          end: {
            line: 322,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 216,
            column: 9
          },
          end: {
            line: 216,
            column: 25
          }
        }, {
          start: {
            line: 217,
            column: 10
          },
          end: {
            line: 321,
            column: 24
          }
        }],
        line: 216
      },
      "16": {
        loc: {
          start: {
            line: 226,
            column: 23
          },
          end: {
            line: 226,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 23
          },
          end: {
            line: 226,
            column: 50
          }
        }, {
          start: {
            line: 226,
            column: 54
          },
          end: {
            line: 226,
            column: 84
          }
        }],
        line: 226
      },
      "17": {
        loc: {
          start: {
            line: 230,
            column: 15
          },
          end: {
            line: 241,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 230,
            column: 15
          },
          end: {
            line: 230,
            column: 28
          }
        }, {
          start: {
            line: 231,
            column: 16
          },
          end: {
            line: 240,
            column: 39
          }
        }],
        line: 230
      },
      "18": {
        loc: {
          start: {
            line: 236,
            column: 29
          },
          end: {
            line: 236,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 236,
            column: 29
          },
          end: {
            line: 236,
            column: 45
          }
        }, {
          start: {
            line: 236,
            column: 49
          },
          end: {
            line: 236,
            column: 79
          }
        }],
        line: 236
      },
      "19": {
        loc: {
          start: {
            line: 245,
            column: 27
          },
          end: {
            line: 245,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 245,
            column: 27
          },
          end: {
            line: 245,
            column: 63
          }
        }, {
          start: {
            line: 245,
            column: 67
          },
          end: {
            line: 245,
            column: 97
          }
        }],
        line: 245
      },
      "20": {
        loc: {
          start: {
            line: 250,
            column: 17
          },
          end: {
            line: 259,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 250,
            column: 17
          },
          end: {
            line: 250,
            column: 47
          }
        }, {
          start: {
            line: 251,
            column: 18
          },
          end: {
            line: 258,
            column: 31
          }
        }],
        line: 250
      },
      "21": {
        loc: {
          start: {
            line: 252,
            column: 21
          },
          end: {
            line: 257,
            column: 21
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 252,
            column: 21
          },
          end: {
            line: 255,
            column: 75
          }
        }, {
          start: {
            line: 256,
            column: 22
          },
          end: {
            line: 256,
            column: 162
          }
        }],
        line: 252
      },
      "22": {
        loc: {
          start: {
            line: 252,
            column: 22
          },
          end: {
            line: 255,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 252,
            column: 22
          },
          end: {
            line: 252,
            column: 39
          }
        }, {
          start: {
            line: 253,
            column: 22
          },
          end: {
            line: 253,
            column: 53
          }
        }, {
          start: {
            line: 254,
            column: 22
          },
          end: {
            line: 254,
            column: 63
          }
        }, {
          start: {
            line: 255,
            column: 22
          },
          end: {
            line: 255,
            column: 70
          }
        }],
        line: 252
      },
      "23": {
        loc: {
          start: {
            line: 260,
            column: 17
          },
          end: {
            line: 272,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 260,
            column: 17
          },
          end: {
            line: 260,
            column: 47
          }
        }, {
          start: {
            line: 261,
            column: 18
          },
          end: {
            line: 261,
            column: 46
          }
        }, {
          start: {
            line: 262,
            column: 20
          },
          end: {
            line: 271,
            column: 33
          }
        }],
        line: 260
      },
      "24": {
        loc: {
          start: {
            line: 264,
            column: 33
          },
          end: {
            line: 266,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 264,
            column: 33
          },
          end: {
            line: 264,
            column: 50
          }
        }, {
          start: {
            line: 265,
            column: 24
          },
          end: {
            line: 265,
            column: 55
          }
        }, {
          start: {
            line: 266,
            column: 24
          },
          end: {
            line: 266,
            column: 63
          }
        }],
        line: 264
      },
      "25": {
        loc: {
          start: {
            line: 273,
            column: 17
          },
          end: {
            line: 284,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 273,
            column: 17
          },
          end: {
            line: 273,
            column: 27
          }
        }, {
          start: {
            line: 274,
            column: 18
          },
          end: {
            line: 283,
            column: 31
          }
        }],
        line: 273
      },
      "26": {
        loc: {
          start: {
            line: 285,
            column: 17
          },
          end: {
            line: 310,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 285,
            column: 17
          },
          end: {
            line: 285,
            column: 28
          }
        }, {
          start: {
            line: 286,
            column: 18
          },
          end: {
            line: 309,
            column: 29
          }
        }],
        line: 285
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0, 0, 0],
      "23": [0, 0, 0],
      "24": [0, 0, 0],
      "25": [0, 0],
      "26": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "48be6fd071d433532e30abe5774e285cea8382a0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_b4bbjxzqs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_b4bbjxzqs();
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var _ref = (cov_b4bbjxzqs().s[0]++, _stylingConstants.default),
  mediaQueries = _ref.mediaQueries;
cov_b4bbjxzqs().s[1]++;
var handleCustomHeaderOnLoad = function handleCustomHeaderOnLoad(evt) {
  cov_b4bbjxzqs().f[0]++;
  var iframe = (cov_b4bbjxzqs().s[2]++, evt.target);
  cov_b4bbjxzqs().s[3]++;
  (0, _utils.iframeResizer)(iframe);
};
var HeaderNavLinks = (cov_b4bbjxzqs().s[4]++, (0, _styledComponents.default)(_HeaderStyles.HeaderNav)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  align-items: flex-end;\n  width: 100%;\n"]))));
var DesktopLogo = (cov_b4bbjxzqs().s[5]++, (0, _styledComponents.default)(_HeaderStyles.HeaderLink)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: none;\n  ", "\n"])), mediaQueries.tablet(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    display: inherit;\n  "])))));
var MobileLogo = (cov_b4bbjxzqs().s[6]++, _styledComponents.default.a.attrs({
  className: 'stx-mobile-logo'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  display: inherit;\n  ", "\n"])), mediaQueries.tablet(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    display: none;\n  "])))));
var SkipLink = (cov_b4bbjxzqs().s[7]++, _styledComponents.default.a.attrs({
  className: "stx-skip-link"
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  background: #000000;\n  color: #ffffff;\n  height: 20px;\n  left: 50%;\n  padding: 8px;\n  position: absolute;\n  transform: translateY(-100%);\n  transition: transform 0.3s;\n\n  &:focus {\n    transform: translateY(0%);\n  }\n"]))));
var CustomHeaderWrapper = (cov_b4bbjxzqs().s[8]++, _styledComponents.default.div.attrs({
  className: "stx-custom-header-wrapper"
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)([""]))));
var WRONG_FORMAT = (cov_b4bbjxzqs().s[9]++, "WRONG FORMAT");
var KEY_CODE = (cov_b4bbjxzqs().s[10]++, {
  ENTER: 13
});
var skipToContentText = (cov_b4bbjxzqs().s[11]++, "Skip to content");
var Header = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Header, _React$Component);
  var _super = _createSuper(Header);
  function Header(_props) {
    var _this;
    (0, _classCallCheck2.default)(this, Header);
    cov_b4bbjxzqs().f[1]++;
    cov_b4bbjxzqs().s[12]++;
    _this = _super.call(this, _props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMobileMenuEnter", (cov_b4bbjxzqs().s[18]++, function (e) {
      cov_b4bbjxzqs().f[3]++;
      cov_b4bbjxzqs().s[19]++;
      if (e.keyCode === KEY_CODE.ENTER) {
        cov_b4bbjxzqs().b[2][0]++;
        cov_b4bbjxzqs().s[20]++;
        _this.toggleMobileMenu();
      } else {
        cov_b4bbjxzqs().b[2][1]++;
      }
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSkipLink", (cov_b4bbjxzqs().s[21]++, function (e) {
      cov_b4bbjxzqs().f[4]++;
      var pageParam = (cov_b4bbjxzqs().s[22]++, window.location.hash.split('#')[1]);
      var focusElement;
      cov_b4bbjxzqs().s[23]++;
      if ((cov_b4bbjxzqs().b[4][0]++, pageParam) && ((cov_b4bbjxzqs().b[4][1]++, pageParam === 'list') || (cov_b4bbjxzqs().b[4][2]++, pageParam === 'calendar'))) {
        cov_b4bbjxzqs().b[3][0]++;
        cov_b4bbjxzqs().s[24]++;
        focusElement = document.getElementById('productList');
      } else {
        cov_b4bbjxzqs().b[3][1]++;
        cov_b4bbjxzqs().s[25]++;
        focusElement = document.getElementById('catalog');
      }
      cov_b4bbjxzqs().s[26]++;
      focusElement.scrollIntoView();
      cov_b4bbjxzqs().s[27]++;
      focusElement.focus();
      cov_b4bbjxzqs().s[28]++;
      e.preventDefault();
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSkipLinks", (cov_b4bbjxzqs().s[31]++, function (skipLinks) {
      cov_b4bbjxzqs().f[7]++;
      cov_b4bbjxzqs().s[32]++;
      if (!(0, _isArray.default)(skipLinks)) {
        cov_b4bbjxzqs().b[5][0]++;
        cov_b4bbjxzqs().s[33]++;
        return null;
      } else {
        cov_b4bbjxzqs().b[5][1]++;
      }
      cov_b4bbjxzqs().s[34]++;
      return skipLinks.map(function (skipLink) {
        cov_b4bbjxzqs().f[8]++;
        var _ref2 = (cov_b4bbjxzqs().s[35]++, skipLink),
          content = _ref2.content,
          path = _ref2.path;
        // return wrong format skip link to inform user.
        cov_b4bbjxzqs().s[36]++;
        if ((cov_b4bbjxzqs().b[7][0]++, !content) || (cov_b4bbjxzqs().b[7][1]++, !path)) {
          cov_b4bbjxzqs().b[6][0]++;
          cov_b4bbjxzqs().s[37]++;
          return /*#__PURE__*/_react.default.createElement(SkipLink, {
            href: "#",
            __self: (0, _assertThisInitialized2.default)(_this),
            __source: {
              fileName: _jsxFileName,
              lineNumber: 139,
              columnNumber: 11
            }
          }, WRONG_FORMAT);
        } else {
          cov_b4bbjxzqs().b[6][1]++;
        }
        cov_b4bbjxzqs().s[38]++;
        return /*#__PURE__*/_react.default.createElement(SkipLink, {
          href: path,
          __self: (0, _assertThisInitialized2.default)(_this),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 145,
            columnNumber: 9
          }
        }, content);
      });
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMobileMenu", (cov_b4bbjxzqs().s[39]++, function (props) {
      cov_b4bbjxzqs().f[9]++;
      var _ref3 = (cov_b4bbjxzqs().s[40]++, props),
        config = _ref3.config,
        defaultLanguage = _ref3.defaultLanguage,
        currentLocale = _ref3.currentLocale,
        changeLanguageFromMobile = _ref3.changeLanguageFromMobile,
        customLinks = _ref3.customLinks,
        user = _ref3.user;
      cov_b4bbjxzqs().s[41]++;
      return /*#__PURE__*/_react.default.createElement(_tsMobileMenu.MobileMenu, {
        user: user,
        toggleMenu: _this.toggleMobileMenu,
        open: _this.state.isMobileMenuOpen,
        config: config,
        defaultLocale: defaultLanguage,
        customLinks: customLinks,
        currentLocale: currentLocale,
        changeLocale: changeLanguageFromMobile,
        mobileMenuRef: _this.mobileMenuRef,
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 162,
          columnNumber: 7
        }
      });
    }));
    cov_b4bbjxzqs().s[13]++;
    _this.mobileMenuRef = /*#__PURE__*/_react.default.createRef();
    cov_b4bbjxzqs().s[14]++;
    _this.state = {
      isMobileMenuOpen: false
    };
    cov_b4bbjxzqs().s[15]++;
    _this.toggleMobileMenu = _this.toggleMobileMenu.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(Header, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_b4bbjxzqs().f[2]++;
      cov_b4bbjxzqs().s[16]++;
      if ((cov_b4bbjxzqs().b[1][0]++, this.state.isMobileMenuOpen) && (cov_b4bbjxzqs().b[1][1]++, this.mobileMenuRef) && (cov_b4bbjxzqs().b[1][2]++, this.mobileMenuRef.current)) {
        cov_b4bbjxzqs().b[0][0]++;
        cov_b4bbjxzqs().s[17]++;
        this.mobileMenuRef.current.focus();
      } else {
        cov_b4bbjxzqs().b[0][1]++;
      }
    }
  }, {
    key: "toggleMobileMenu",
    value: function toggleMobileMenu() {
      var _this2 = this;
      cov_b4bbjxzqs().f[5]++;
      cov_b4bbjxzqs().s[29]++;
      this.setState(function () {
        cov_b4bbjxzqs().f[6]++;
        cov_b4bbjxzqs().s[30]++;
        return {
          isMobileMenuOpen: !_this2.state.isMobileMenuOpen
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      cov_b4bbjxzqs().f[10]++;
      var _ref4 = (cov_b4bbjxzqs().s[42]++, this.props),
        skipLinks = _ref4.skipLinks,
        contactItems = _ref4.contactItems;
      var isSignedIn = (cov_b4bbjxzqs().s[43]++, (0, _keys.default)(this.props.user).length > 0);
      var hasCustomHeader = (cov_b4bbjxzqs().s[44]++, (cov_b4bbjxzqs().b[8][0]++, this.props.theme) && (cov_b4bbjxzqs().b[8][1]++, this.props.theme.hasCustomHeader));
      var hasCustomLogo = (cov_b4bbjxzqs().s[45]++, (cov_b4bbjxzqs().b[9][0]++, this.props.theme) && (cov_b4bbjxzqs().b[9][1]++, this.props.theme.headerLogoUrl));
      var cartNumberOfItems = (cov_b4bbjxzqs().s[46]++, (cov_b4bbjxzqs().b[10][0]++, this.props.totalItemsCart) || (cov_b4bbjxzqs().b[10][1]++, 0));
      var _ref5 = (cov_b4bbjxzqs().s[47]++, this.props.config.configuration),
        baseUrl = _ref5.baseUrl;
      var LogoLink = (cov_b4bbjxzqs().s[48]++, (cov_b4bbjxzqs().b[11][0]++, this.props.config) && (cov_b4bbjxzqs().b[11][1]++, this.props.config.configuration) && (cov_b4bbjxzqs().b[11][2]++, this.props.config.configuration.continueShoppingURL) || (cov_b4bbjxzqs().b[11][3]++, baseUrl));
      var styles = (cov_b4bbjxzqs().s[49]++, (0, _get.default)(this.props, 'config.style.properties', null));
      var skipLinkComponents = (cov_b4bbjxzqs().s[50]++, this.renderSkipLinks(skipLinks));
      var mobileMenuComponent = (cov_b4bbjxzqs().s[51]++, this.state.isMobileMenuOpen ? (cov_b4bbjxzqs().b[12][0]++, this.renderMobileMenu(this.props)) : (cov_b4bbjxzqs().b[12][1]++, null));
      var contactToShow = (cov_b4bbjxzqs().s[52]++, (0, _TsHeaderHelper.getContactToShow)(contactItems, this.props.currentLocale));
      cov_b4bbjxzqs().s[53]++;
      return /*#__PURE__*/_react.default.createElement(_HeaderStyles.Wrapper, {
        showBgImagesOnMobile: (cov_b4bbjxzqs().b[13][0]++, styles) && (cov_b4bbjxzqs().b[13][1]++, styles.showBgImagesOnMobile),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 195,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(SkipLink, {
        href: "/",
        onClick: this.handleSkipLink,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 197,
          columnNumber: 9
        }
      }, skipToContentText), skipLinkComponents, (cov_b4bbjxzqs().b[14][0]++, hasCustomHeader) && (cov_b4bbjxzqs().b[14][1]++, /*#__PURE__*/_react.default.createElement(CustomHeaderWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 202,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement("iframe", {
        title: "stx-custom-header",
        id: "stx-custom-header",
        src: this.props.urlSourceIframe,
        height: "100%",
        width: "100%",
        frameBorder: "0",
        scrolling: "no",
        onLoad: handleCustomHeaderOnLoad,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 203,
          columnNumber: 13
        }
      }), mobileMenuComponent)), (cov_b4bbjxzqs().b[15][0]++, !hasCustomHeader) && (cov_b4bbjxzqs().b[15][1]++, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderInner, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 217,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderLeft, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 218,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderToggle, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 219,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderLink, (0, _extends2.default)({
        title: "Menu",
        role: "button",
        onClick: this.toggleMobileMenu,
        onKeyDown: this.handleMobileMenuEnter,
        "aria-expanded": this.state.isMobileMenuOpen
      }, (cov_b4bbjxzqs().b[16][0]++, this.state.isMobileMenuOpen) && (cov_b4bbjxzqs().b[16][1]++, "aria-controls: ts-MobileMenu"), {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 220,
          columnNumber: 17
        }
      }), /*#__PURE__*/_react.default.createElement(_icon.default, {
        iconName: "menu",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 227,
          columnNumber: 19
        }
      }))), (cov_b4bbjxzqs().b[17][0]++, hasCustomLogo) && (cov_b4bbjxzqs().b[17][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.TsHeader.title",
        values: {
          organization: (0, _get.default)(this.props, "config.configuration.organizationName[".concat(this.props.currentLocale, "]"), "")
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 231,
          columnNumber: 17
        }
      }, function (title) {
        cov_b4bbjxzqs().f[11]++;
        cov_b4bbjxzqs().s[54]++;
        return /*#__PURE__*/_react.default.createElement(DesktopLogo, {
          href: LogoLink,
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 234,
            columnNumber: 21
          }
        }, /*#__PURE__*/_react.default.createElement(_logo.default, {
          src: (cov_b4bbjxzqs().b[18][0]++, _this3.props.theme) && (cov_b4bbjxzqs().b[18][1]++, _this3.props.theme.headerLogoUrl),
          alt: title,
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 235,
            columnNumber: 23
          }
        }));
      }))), /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderCenter, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 243,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(MobileLogo, {
        href: LogoLink,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 244,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(_logo.default, {
        src: (cov_b4bbjxzqs().b[19][0]++, this.props.theme.headerMobileLogoUrl) || (cov_b4bbjxzqs().b[19][1]++, this.props.theme.headerLogoUrl),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 245,
          columnNumber: 17
        }
      }))), /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderRight, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 248,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderList, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 249,
          columnNumber: 15
        }
      }, (cov_b4bbjxzqs().b[20][0]++, !this.props.isToggleMenuActive) && (cov_b4bbjxzqs().b[20][1]++, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 251,
          columnNumber: 19
        }
      }, (cov_b4bbjxzqs().b[21][0]++, ((cov_b4bbjxzqs().b[22][0]++, this.props.config) && (cov_b4bbjxzqs().b[22][1]++, this.props.config.configuration) && (cov_b4bbjxzqs().b[22][2]++, this.props.config.configuration.languages) && (cov_b4bbjxzqs().b[22][3]++, this.props.config.configuration.languages.length)) > 1) && (cov_b4bbjxzqs().b[21][1]++, /*#__PURE__*/_react.default.createElement(_languageSelector.default, {
        config: this.props.config,
        changeLocale: this.props.changeLocale,
        displayLanguageCode: this.props.displayLanguageCode,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 256,
          columnNumber: 23
        }
      })))), (cov_b4bbjxzqs().b[23][0]++, !this.props.isToggleMenuActive) && (cov_b4bbjxzqs().b[23][1]++, this.props.showCartIndicator) && (cov_b4bbjxzqs().b[23][2]++, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 262,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderLink, {
        href: "".concat((cov_b4bbjxzqs().b[24][0]++, this.props.config) && (cov_b4bbjxzqs().b[24][1]++, this.props.config.configuration) && (cov_b4bbjxzqs().b[24][2]++, this.props.config.configuration.baseUrl), "cart/shoppingCart?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 263,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement(_cartIndicator.default, {
        indicator: cartNumberOfItems,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 269,
          columnNumber: 25
        }
      })))), (cov_b4bbjxzqs().b[25][0]++, isSignedIn) && (cov_b4bbjxzqs().b[25][1]++, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 274,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderHideOnMobile, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 275,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_UserInfo.default, (0, _extends2.default)({}, this.props.user, {
        contactToShow: contactToShow,
        onClick: this.toggleMobileMenu,
        isMobileMenuOpen: this.state.isMobileMenuOpen,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 276,
          columnNumber: 23
        }
      }))))), (cov_b4bbjxzqs().b[26][0]++, !isSignedIn) && (cov_b4bbjxzqs().b[26][1]++, /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 286,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 287,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderHideOnMobile, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 288,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderButton, {
        className: "stx-SignInButton",
        small: true,
        flat: true,
        href: "".concat(baseUrl, "account/login?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 289,
          columnNumber: 25
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.TsHeader.signInButton",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 294,
          columnNumber: 27
        }
      })))), /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 298,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderHideOnMobile, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 299,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderButton, {
        className: "stx-RegisterButton",
        small: true,
        bold: true,
        href: "".concat(baseUrl, "account/register?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 300,
          columnNumber: 25
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.TsHeader.registerButton",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 305,
          columnNumber: 27
        }
      }))))))), mobileMenuComponent, /*#__PURE__*/_react.default.createElement(_HeaderStyles.HeaderHideOnMobile, {
        className: "stx-HeaderNavContainer",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 315,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(HeaderNavLinks, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 316,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement(_CustomLinks.default, {
        links: this.props.customLinks,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 317,
          columnNumber: 19
        }
      })))))));
    }
  }]);
  return Header;
}((_react.default.Component));
cov_b4bbjxzqs().s[55]++;
Header.defaultProps = {
  currentLocale: 'en',
  defaultLanguage: 'en',
  user: {},
  customLinks: [],
  isToggleMenuActive: false,
  onLocaleSwitch: function onLocaleSwitch() {
    cov_b4bbjxzqs().f[12]++;
  },
  urlSourceIframe: '',
  totalItemsCart: 0,
  showCartIndicator: true,
  displayLanguageCode: false,
  skipLinks: [],
  contactItems: [],
  changeLanguageFromMobile: function changeLanguageFromMobile() {
    cov_b4bbjxzqs().f[13]++;
  }
};
cov_b4bbjxzqs().s[56]++;
Header.propTypes = {
  /** config Object provided by the nucleo */
  config: _config.ConfigType.isRequired,
  /** Function to call in case of change of language */
  changeLocale: _propTypes.default.func.isRequired,
  /** Theme provided by styled components */
  theme: _propTypes.default.objectOf(_propTypes.default.string).isRequired,
  isToggleMenuActive: _propTypes.default.bool,
  currentLocale: _propTypes.default.string,
  defaultLanguage: _propTypes.default.string,
  user: _propTypes.default.shape(_config.UserInfoType),
  customLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    rank: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    style: _propTypes.default.string,
    name: _propTypes.default.objectOf(_propTypes.default.string)
  })),
  urlSourceIframe: _propTypes.default.string,
  totalItemsCart: _propTypes.default.number,
  showCartIndicator: _propTypes.default.bool,
  displayLanguageCode: _propTypes.default.bool,
  contactItems: _propTypes.default.arrayOf(_propTypes.default.object),
  skipLinks: _propTypes.default.arrayOf(_propTypes.default.object),
  changeLanguageFromMobile: _propTypes.default.func
};
// TODO remove the withTheme function, but for the moment, it is convenient.
var _default = exports.default = (0, _styledComponents.withTheme)(Header);